// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Form_form__110YQ {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden; }\n", ""]);
// Exports
exports.locals = {
	"form": "Form_form__110YQ"
};
module.exports = exports;
